// Copyright (c) StrangeBee 2024

import { ObservableTypeController, ObservableTypeInput, ObservableTypeOutput } from 'thehive-sdk';

export interface ObservableTypeEventList {
    onCreate: (observableType: ObservableTypeInput) => void;
    onDelete: (observableTypeId: string) => void;
    onList: () => Promise<ObservableTypeOutput[]>;
}

interface ObservableTypeEventListParams {
    locale?: (label: string) => string;
    controller: ObservableTypeController;
    onSuccess?: (count?: boolean, message?: string) => void;
    onError?: (label?: string) => void;
}

export const computeEventList = ({
    controller,
    locale,
    onError,
    onSuccess,
}: ObservableTypeEventListParams): ObservableTypeEventList => ({
    onCreate: (observableType): void => {
        controller
            .create(observableType)
            .then((): void => onSuccess?.(true, locale?.('notification.observable-type.create')))
            .catch(onError);
    },
    onDelete: (observableTypeId): void => {
        controller
            .delete(observableTypeId)
            .then((): void => onSuccess?.(true, locale?.('notification.observable-type.delete')))
            .catch(onError);
    },
    onList: () =>
        controller.list<ObservableTypeOutput[]>({
            selector: {
                head: [{ name: 'listObservableType' }],
                name: 'get-all-observable-types',
                sort: ['+name'],
            },
        }),
});
